<template>
    <Popup ref="popup" :animation="'scale'" >
        <div class="logout-cont" >
            <div class="close-btn" @click.stop="hide" >
                <img :src="_global.assetsRoot + '/common/pop_btn_close.png'" />
            </div>
            <img class="logout-title-img" :src="getTitleImage()" />
            <div class="t-c confirm-text" >
                <span class="beba" >{{ $t("message.confirmLogout") }}</span>
            </div>
            <div class="btns" >
                <div class="btn confirm t-c" @click.stop="hide" >
                    <span class="btn-text beba" >{{ $t("message.stayLoggedIn") }}</span>
                </div>
                <div class="btn cancel t-c" @click.stop="logout" >
                    <span class="btn-text beba" >{{ $t("message.logMeOut") }}</span>
                </div>
            </div>
        </div>
    </Popup>
</template>

<script>
import Popup from '../Popup.vue'
export default {
    data() {
        return {}
    },
    methods: {
        show() { this.$refs.popup.show() },
        hide() { this.$refs.popup.hide() },
        logout() {
            this.$emit('logout');
            this.hide();
        },
        getTitleImage() {
            let userLanguage = this._global.user.lang || 'en';
            const langMap = {
                'pt': 'pt',
                'es': 'es',
                'en': 'en'
            };
            const lang = langMap[userLanguage] || 'en';
            return this._global.assetsRoot + `/common/pop_logout_title_${lang}.png`;
        }
    },
    components: { Popup }
}
</script>

<style lang="scss" >
@import "../../assets/css/variables.scss";
.logout-cont {
    width: 75vw;
    background: url($assetRoot + "/common/pop_logout_bg.png") center no-repeat;
    background-size: 100% 100%;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 1rem 2rem;
    position: relative;

    span {
        color: #FFF;
    }

    .close-btn {
        position: absolute;
        top: -1.5rem;
        right: -0.5rem;
        z-index: 10;
        cursor: pointer;

        img {
            width: 4rem;
            height: 4rem;
        }
    }

    .logout-title-img {
        width: 100%;
        position: absolute;
        top: 2rem;
        left: 0;
        z-index: 5;
        scale: .9;
    }

    .confirm-text {
        margin-bottom: 4rem;
        margin-top: 8rem;

        span {
            display: block;
            color: #FFF;
            line-height: 1.4rem;
            opacity: 0.85;
            font-size: 2rem;
            font-weight: bold;
            text-shadow:
                -2px -2px 0 #2641bf,
                0px -2px 0 #2641bf,
                2px -2px 0 #2641bf,
                -2px  0px 0 #2641bf,
                2px  0px 0 #2641bf,
                -2px  2px 0 #2641bf,
                0px  2px 0 #2641bf,
                2px  2px 0 #2641bf;
        }
    }

    .btns {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 2rem;

        .btn {
            position: relative;
            width: 12rem;
            height: 4.2rem;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            .btn-text {
                color: #FFFFFF;
                font-size: 2rem;
                font-weight: bold;
                text-shadow:
                    -1px -1px 0 #000000,
                    0px -1px 0 #000000,
                    1px -1px 0 #000000,
                    -1px  0px 0 #000000,
                    1px  0px 0 #000000,
                    -1px  1px 0 #000000,
                    0px  1px 0 #000000,
                    1px  1px 0 #000000;
            }
        }

        .confirm {
            background: url($assetRoot + "/common/btn_logout_stay.png") center no-repeat;
            background-size: contain;
            width: 100%;
            height: 5rem;
        }

        .cancel {
             background: url($assetRoot + "/common/btn_logout_out.png") center no-repeat;
            background-size: contain;
            width: 100%;
            height: 5rem;
            margin-bottom: 2rem;
        }
    }
}

@media (min-width: 1025px) {
    .logout-cont {
        width: clamp(35rem, 44vw, 58rem);
        padding: 1.2vw 2.2vw;

        .close-btn {
            top: -1.2vw;
            right: -0.4vw;

            img {
                width: clamp(2.8rem, 3.3vw, 4rem);
                height: clamp(2.8rem, 3.3vw, 4rem);
            }
        }

        .logout-title-img {
            top: 1.4vw;
            scale: .8;
        }

        .confirm-text {
            margin-top: 8.8vw;
            margin-bottom: 2.3vw;

            span {
                font-size: clamp(1.8rem, 2vw, 2.6rem);
                line-height: 1.2;
            }
        }

        .btns {
            gap: 1.4vw;

            .btn {
                height: 4.2vw;

                .btn-text {
                    font-size: clamp(1.6rem, 1.9vw, 2.2rem);
                }
            }

            .confirm,
            .cancel {
                height: 4.8vw;
            }

            .cancel {
                margin-bottom: 1.1vw;
            }
        }
    }
}

.mobile{
    .logout-cont{
        .confirm-text {
            margin-top: 6rem;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/popup/Logout.vue